import { render, staticRenderFns } from "./BulkDeleteIcon.vue?vue&type=template&id=4a1e3cd4"
import script from "./BulkDeleteIcon.vue?vue&type=script&lang=js"
export * from "./BulkDeleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports